import type { ComponentProps } from "react";
import * as Tabs from "@radix-ui/react-tabs";
import { Suspense } from "react";
import { SidebarLoading } from "./SidebarLoading";
import { Headline } from "@acdc2/ui/components/access-typography";

type Props = ComponentProps<typeof Tabs.Content> & {
  title: string;
  right?: React.ReactNode;
  children?: React.ReactNode;
};

export function NavbarTabContent({
  title,
  right,
  children,
  ...tabsContentProps
}: Props) {
  return (
    <Tabs.Content {...tabsContentProps} asChild>
      <div className="h-full flex flex-col">
        <div className="h-14 shrink-0 border-b px-4 py-2 flex flex-row gap-4 items-center justify-between">
          <Headline asChild>
            <h2>{title}</h2>
          </Headline>
          <div>{right}</div>
        </div>
        <Suspense fallback={<SidebarLoading />}>{children}</Suspense>
      </div>
    </Tabs.Content>
  );
}
